import { createApiSlice } from "@common";
import { CRUD_OPPORTUNITY_COMPETITOR_ANALYSIS } from "@routes";

const apiConfig = [
  {
    name: "addOpportunityCompetitorAnalysis",
    method: "post",
    url: CRUD_OPPORTUNITY_COMPETITOR_ANALYSIS,
    stateKey: "message",
  },
  {
    name: "getOpportunityCompetitorAnalysis",
    method: "get",
    url: CRUD_OPPORTUNITY_COMPETITOR_ANALYSIS,
    stateKey: "data",
  },
  {
    name: "updateOpportunityCompetitorAnalysis",
    method: "put",
    url: CRUD_OPPORTUNITY_COMPETITOR_ANALYSIS,
    stateKey: "message",
  },
  {
    name: "deleteOpportunityCompetitorAnalysis",
    method: "delete",
    url: CRUD_OPPORTUNITY_COMPETITOR_ANALYSIS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "opportunityCompetitorAnalysis",
  apiConfig,
  customReducers
);

const opportunityCompetitorAnalysisSlice = slice;

export default opportunityCompetitorAnalysisSlice.reducer;

export const {
  addOpportunityCompetitorAnalysis,
  getOpportunityCompetitorAnalysis,
  updateOpportunityCompetitorAnalysis,
  deleteOpportunityCompetitorAnalysis,
} = thunks;

export const { rowSelect: rowSelectOpportunityCompetitorAnalysis } = actions;
